import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import CloseButton from './common/close-button';
import HeaderIcon from './common/header-icon';

class MtvDrawer extends Component {
    constructor(props) {
        super(props);

        //console.log("[MtvDrawer] props:",props);
        require('./mtv-drawer.scss');
    }
    componentDidUpdate() {
        //console.log("[MtvDrawer] Update:",this.props);
    }
    render() {
        const {open } = this.props;
        /*
        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                key: "drawer-content",
                content
            });
        });
        */
        return (
            <Drawer key="mtv-drawer" anchor="right" open={open} onClose={this.props.onClose} classes={ { root: "mtv-drawer", paper: "mtv-drawer-paper" } } >
                <div className="content-container" >
                    <div className="header-container">
                        <h2><span className="icon-container"><HeaderIcon /></span><span className="header-name">{this.props.header}</span></h2>
                        <CloseButton onClick={this.props.onClose} />
                    </div>
                    { this.props.children }
                </div>
          </Drawer>
        )
    }
    static get propTypes() {
        return {
            open: PropTypes.bool,
            onClose: PropTypes.func,
            children: PropTypes.any,
            header: PropTypes.string
        }
    }
}

export default MtvDrawer